import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import ShippingGuidePage from "@/pages/article/shipping-guide/page";
import BeginnersGuidePage from "@/pages/article/beginners-guide/page";
import TemplateGuidePage from "@/pages/article/template-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/superbuy-spreadsheet-complete-guide",
    element: <ArticlePage />,
  },
  {
    path: "/article/superbuy-spreadsheet-shipping-guide",
    element: <ShippingGuidePage />,
  },
  {
    path: "/article/superbuy-spreadsheet-for-beginners",
    element: <BeginnersGuidePage />,
  },
  {
    path: "/article/superbuy-spreadsheet-template-guide",
    element: <TemplateGuidePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;